import { Injectable, inject } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from '../services/storage.service';
import CommonUtils from '../utils/common.utils'
@Injectable({
  providedIn: 'root'
})
class RoleGuardService {

  constructor(
    private _router: Router,
    private storageService: StorageService) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const permissions = JSON.parse(this.storageService.getPermission('permissions'));
    if (permissions && CommonUtils.checkValueIsExistInBothArray(next.data.role, permissions)) {
      return true;
    } else {
      this._router.navigate(['pages/dashboard']);
    }

    
    if(!this.storageService.getStorageItem('isCustomerSelected') || this.storageService.getStorageItem('isCustomerSelected') == "false") {
      this._router.navigate(['pages/customers']);
    }
    return false;
  }
}

export const RoleGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(RoleGuardService).canActivate(next,state);
}
